import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-marketplace-cart-drawer',
  templateUrl: './cv-marketplace-cart-drawer.component.html',
  styleUrls: ['./cv-marketplace-cart-drawer.component.scss']
})
export class CvMarketplaceCartDrawerComponent implements OnInit {
  @Input() autoHideScrollbar = false;
  @Input() pointStoreProducts = [];
  @Input() highlightCartItem: boolean = false;
  @Input() lastAdded = null;
  @Input() products = [];

  public localization: Map<string, string> = new Map();

  @Output() deleteItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() goToCartEvent: EventEmitter<any> = new EventEmitter<any>();

  public isCxOne: boolean = false;

  constructor(private shoppingCartService: ShoppingCartService,
              private cvConfigurationService: CvConfigurationService,
              private locService: CVLocalizationService) 
  {
    this.isCxOne = cvConfigurationService.isCxOne;
  }

  async ngOnInit() {
    this.localization = await this.locService.GetSection("MarketPlace") ?? new Map<string, string>();
  }

  deleteItemFromCart(product) {
    this.deleteItem.emit(product);
  }

  getProductImage(cartItem) {
    if (cartItem != null && this.pointStoreProducts != null) {
      if (cartItem.ProductImageID != null && cartItem.ProductImageID > 0) {
        if (cartItem.Variation != null && cartItem.Variation > 0 && cartItem.VariationImgID != null && cartItem.VariationImgID > 0) {
          return '../Admin/ImageResizer.aspx?imgid=' + cartItem.VariationImgID + '&w=auto&h=200';
        } else
          return '../Admin/ImageResizer.aspx?imgid=' + cartItem.ProductImageID + '&w=auto&h=200';
      } else
      {
        if (cartItem.Variation != null && cartItem.Variation > 0 && cartItem.VariationImgID != null && cartItem.VariationImgID > 0) {
          return '../Admin/ImageResizer.aspx?imgid=' + cartItem.VariationImgID + '&w=auto&h=200';
        } else {
          return '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80';
        } 
      }
          
    }
  }

  calculateCartTotal(): number {
    return this.shoppingCartService.getCartTotal();
  }
  goToCart() {
    this.goToCartEvent.emit();
  }

  getVariationName(productId): string {
    let variationName: string = '';
    if (this.products) {
      variationName = this.products.find(x => x.PointStoreProductID == productId) == null ? '' : this.products.find(x => x.PointStoreProductID == productId).VariationName;
    }
    return variationName;
  }

}
